const SessionFilter = ({value, onChange, style = {}}) => (
  <select name='session' style={{width: '150px', height: '40px', ...style}} className='form-control rounded' value={value} onChange={e => onChange(e.target.value)}>
    <option value=''>Session</option>
    <option value='morning'>Morning</option>
    <option value='evening'>Evening</option>
  </select>
);

export default SessionFilter;
